export default {"src":"/_next/static/image/src/assets/footer/logo.4355f9e2929bf2e074269a2edcd7184f.svg","height":100,"width":156};